module.exports = __webpack_public_path__ + "img/daniel-becker.ca0c863d.png";